export default {
	home: 'Inicio',
	aboutUs: 'Nosotros',
	contact: 'Contacto',
	logout: 'Cerrar sesión',
	login: 'Iniciar sesión',
	register: 'Registrate aquí',
	search: 'Buscar',
	login_fa: 'Login con facebook',
	login_go: 'Login con Google',
	sign_in_man: 'Iniciar sesión manualmente',
	username: 'Nombre de usuario',
	password: 'Contraseña',
	btn_register: 'Regístrate ahora',
	btn_lost_pass: 'Se te olvidó tu contraseña?',
	text_remenber: 'Recordarme',
	check_in: 'Registrarse',
	itfa_abr: 'ASOCIACIÓN INDEPENDIENTE TELEFOOTBALL',
	t_platform: 'ciona una plataforma',
	about_us:
		'<p>Con el fin de conseguir lo más cercano a <strong>nuestra manera</strong> de dirigir una competición lo mas real que se pueda en FIFA nos gustaría resaltar algunos detalles sobre lo que es su experiencia en este juego.</p><p>Actualmente tenemos alrededor de 800+ jugadores en nuestros Pro Clubes y Grupos 1vs1 esta proximamente a realizarse, donde muchos están involucrados en una u otra de las competencias que son exclusivas para PS4 debido a diversas razones.</p><p>Esta página web, esta echa para todos ustedes donde habra torneos sobre FIFA 16.</p><p>– 1 VS 1 donde podras demostrar tu habilidad.</p><p>– PRO CLUBS es un modo de juego online de FIFA 16 donde puedes crear un jugador Virtual Pro y jugar en tu misma posición en el campo con tus compañeros del modo más realista que puedes vivir el fútbol online. Cuantos más partidos juegues y más hazañas desbloquees, tu Virtual Pro desbloqueará mejores atributos y más opciones de aspecto. Juega partidos informales o bien únete a un club o crea el tuyo para conseguir puntos con tu propio club.</p><p>También podrá interactuar con nosotros,mardar las fotos de tu club oh videos, contactarnos, hacer preguntas y enviar sugerencias y comentarios relacionados con nuestra forma de como llevamos la pagina web y administracion, asegurando poder atenderlos y responderle lo mas pronto posible con algun problema que tengan.</p><p><strong>Un cordial saludo.</strong></p><p>Esperamos poder cumplir con sus expectativas con calidad rapidez y satisfacción, ya que es nuestra verdadera filosofía de trabajo fifa16.</p>',
	text_contact:
		'<p>Gracias por su visita.</p><p>Si tienes alguna sugerencia, reclamo o comentario no dudes en escribirnos, nosotros estaremos gustosos de responderte.</p>',
	subject: 'Asunto',
	email: 'Correo electrónico',
	name: 'Nombre',
	message: 'Mensaje',
	messages: 'Mensajes',
	required: 'Requerido',
	submit: 'Enviar',
	return: 'Regresar',
	pleaseWait: 'Espere por favor...',
	registerTitle: 'Registro de Usuarios',
	repeatPassword: 'Repita su contraseña',
	country: 'País',
	position: 'Posición',
	console: 'Consola',
	motto: 'Lema',
	selectOption: 'Selecciona una opción',
	allRightsReserved: 'Todos los derechos reservados',
	profile: 'Perfil',
	myProfile: 'Mi perfil',
	friends: 'Amigos',
	edit: 'Editar',
	editUser: 'Editar mi información',
	language: 'Idioma',
	save: 'Guardar',
	changePassword: 'Cambiar contraseña',
	currentPassword: 'Contraseña actual',
	newPassword: 'Contraseña nueva',
	repeatNewPassword: 'Repetir contraseña nueva',
	options: 'Opciones',
	favorites: 'Favoritos',
	createAdmins: 'Crear administradores',
	sliderPrimary: 'Slider principal',
	changeGt: 'Cambiar gamertag',
	toPremium: 'Cambiar a premium',
	updatedData: 'Actualizar datos',
	tutorialCreate: 'Crear tutorial',
	bets: 'Apuestas',
	textChangeImgSlider:
		'<li>La imagen no debe de tener un peso mayor a 2 MB.</li><li>Resolución minima 1366 x 598 pixeles.</li><li>La única extensión permitida es JPG.</li>',
	findImage: 'Buscar imagen',
	details: 'Detalles',
	updatedInfo: 'Información actualizada.',
	create: 'Crear',
	title: 'Título',
	delete: 'Eliminar',
	error404: 'El recurso no existe.',
	enterUserId: 'Ingresa el id del usuario',
	cancel: 'Cancelar',
	confirmTitleDelete: 'Confirmar eliminación',
	confirmTextDelete: '¿Esta seguro de querer eliminar el item seleccionado?',
	editInfoUser: 'Editar info usuario',
	resetPassword: 'Restabler su contraseña',
	enterYourEmail: 'Ingresa tu correo electrónico',
	myNews: 'Mis noticias',
	image: 'Imagen',
	published: 'Publicado',
	modified: 'Modificado',
	comments: 'Comentarios',
	date: 'Fecha',
	time: 'Hora',
	createdAgo: 'Creado hace',
	content: 'Contenido',
	cover: 'Portada',
	show: 'Mostrar',
	enterIdOrUsername: 'Ingresa el ID o el nombre de usuario de un jugador',
	month: 'mes | meses',
	year: 'año | años',
	selectPlatform: 'Selecciona una plataforma',
	langEs: 'Español',
	langEn: 'Inglés',
	langPt: 'Portugués',
	description: 'Descripción',
	videoCode: 'Código del video',
	order: 'orden',
	tournaments: 'Torneos',
	tournament: 'Torneo',
	online: 'En linea',
	notices: 'Noticias',
	readMore: 'Leer más',
	seeAllNews: 'Ver todas las noticias',
	rankingPlayers: 'Ranking de jugadores',
	rankingTeams: 'Ranking  de equipos',
	lastMatches: 'Últimos partidos',
	round: 'ronda | rondas',
	theBest: 'Los mejores',
	signings: 'Fichajes',
	rules: 'Reglas',
	divisions: 'Divisiones',
	division: 'Division',
	teams: 'Equipos',
	team: 'Equipo',
	transfers: 'Transferencias',
	assistances: 'Asistencias',
	scorer: 'Goleador | Goleadores',
	transferClose: 'faltan {time} para el cierre',
	transferOpen: 'faltan {time} para abrir',
	goal: 'gol | goles',
	assistance: 'asistencia | asistencias',
	goalkeeper: 'Guardameta | Guardametas',
	bestPlayer: 'Mejor jugador',
	point: 'punto | puntos',
	bestDefense: 'La mejor defensa',
	bestOffensive: 'La mejor ofensiva',
	goalFavor: 'gol a favor | goles a favor',
	goalAgainst: 'gol en contra | goles en contra',
	player: 'Jugador',
	players: 'Jugadores',
	ranking: 'Ranking',
	status: 'Estado',
	price: 'Precio',
	purchasedBy: 'Comprado por',
	availableMoney: 'Dinero disponible',
	free: 'Libre',
	signing: 'Fichado',
	playedGames: 'Partidos jugados',
	yellowCard: 'tarjeta amarilla | tarjetas amarillas',
	redCard: 'tarjeta roja | tarjetas rojas',
	joinTheMarket: 'Unirme al mercado',
	joinTheMarketConfirm:
		'¿ Seguro que quieres unirte a la lista de jugadores libres del torneo?',
	yes: 'Si',
	not: 'No',
	notice: 'Aviso',
	contract: 'Contratar',
	sellPlayers: 'Vender jugadores',
	pendingRounds: 'Rondas pendientes',
	sellerPlayerConfirm:
		'¿Estas seguro de querer vender al jugador seleccionado?',
	table: 'Tabla',
	card: 'tarjeta | tarjetas',
	teamWeek: 'Equipo de la semana',
	nextMatches: 'Próximos partidos',
	results: 'Resultados',
	privateMsgFor: 'Mensaje privado para {user}',
	pj: 'PJ',
	pg: 'PG',
	pe: 'PE',
	pp: 'PP',
	gf: 'GF',
	gc: 'GC',
	dg: 'DG',
	seeDT: 'Ver DT',
	matches: 'Partidos',
	quantity: 'Cantidad',
	training: 'Formación',
	defense: 'Defensas',
	midfielders: 'Mediocampistas',
	front: 'Delanteros',
	award: 'premio | premios',
	champion: 'CAMPEÓN',
	stats: 'Estadísticas',
	type: 'Tipo',
	record: 'Historial',
	changeImage: 'Cambiar imagen',
	addTeam: 'Agregar equipo',
	textFindNotice: 'Ingresa una o mas letras y luego presiona ENTER',
	sendInvitation: 'Enviar invitación',
	createTournament: 'Crear torneo',
	editTournament: 'Editar torneo',
	mode: 'modo',
	category: 'categoría | categorías',
	hideTournament: '¿Ocultar el torneo?',
	deleteAllPlayersOfTeam:
		'¿Estas seguro de borrar a todos los jugadores del equipo seleccionado?',
	handOutMoney: 'Repartir dinero',
	add: 'Agregar',
	remove: 'Quitar',
	transfersClosed: 'Fichajes - está cerrado',
	transfersOpened: 'Fichajes - está abierto',
	transfersClosedMsg:
		'Fichajes está cerrado, los jugadores que fueron invitados ya podrán entrar al equipo.',
	transfersOpenedMsg:
		'Fichajes esta abierto, los jugadores que fueron invitados y no aceptaron ya no podrán entrar al equipo hasta abrir el próximo fichaje.',
	open: 'Abrir',
	close: 'Cerrar',
	customButtons: 'Botones personalizados',
	label: 'Etiqueta',
	showIn: 'Mostrar en',
	selfLink: 'En la misma página',
	blankLink: 'En otra página',
	views: 'Vistas',
	administrator: 'administrador | administradores',
	enterPlayerNick: 'Ingresa el nick de un jugador',
	user: 'usuario',
	roundsFinalPhase: 'ROUNDS + FASE FINAL',
	allFinalPhase: 'TODOS CONTRA TODA + FASE FINAL',
	manualDirectDisposal: 'ELIMINACIÓN DIRECTA MANUAL',
	autoDirectDisposal: 'ELIMINACIÓN DIRECTA AUTOMATICA',
	numberTeamsDown: 'Número de equipos que se van a la baja',
	numberTeamsPassLiguilla: 'Número de equipos que pasan a la liguilla',
	season: 'temporada | temporadas',
	deliverCup: 'Entregar copa',
	removeCup: 'QUITAR COPA',
	toStart: 'POR INICIAR',
	programming: 'EN PROGRAMACION',
	inProgress: 'EN CURSO',
	finished: 'TERMINADO',
	notPresented: 'GANADO POR DEFAULT',
	played: 'JUGADO',
	changeDatesRounds: 'Cambiar las fechas de las rondas',
	addPlayTime: 'Agregar horario de juego',
	selectDays: 'Seleccione uno o más dias de la semana',
	monday: 'Lunes',
	tuesday: 'Martes',
	wednesday: 'Miércoles',
	thursday: 'Jueves',
	friday: 'Viernes',
	saturday: 'Sábado',
	sunday: 'Domingo',
	schedule: 'Horario de juego',
	transferDate: 'Fecha de fichajes',
	endDate: 'Fecha de cierre',
	choose: 'Seleccionar',
	alternate: 'Suplente',
	showFixture: 'Mostrar fixture',
	msgCreateFixture:
		'Despues de crear el fixture ya no se pueden agregar más equipo al torneo. Esta seguro de continuar?',
	createFixture: 'Crear fixture',
	btnIfContinue: 'Si, deseo continuar',
	createLiguilla: 'Crear liguilla',
	thirdPlace: 'Tercer Lugar',
	myClub: 'Mi club',
	myTeams: 'Mis equipos',
	myGames: 'Mis partidos',
	management: 'Gestión',
	tshirts: 'Camisetas',
	notification: 'notificación | notificaciones',
	from: 'De',
	detailsNotification: 'Detalles de la Notificación',
	invitation: 'invitación | invitaciones',
	accept: 'Aceptar',
	deny: 'Rechazar',
	invitationAccepted: 'Invitación aceptada.',
	invitationRejected: 'Invitación rechazada.',
	transferPlayer: 'Transferir jugador',
	freePlayerPremium: '¿Deseas liberar al jugador seleccionado?',
	trainingShow: 'Formación para mostrar',
	teamFormation: 'Formación del equipo',
	myFormation: 'Mi formación',
	invitePlayers: 'Invitar jugadores',
	myFavouriteTeams: 'Mis equipos favoritos',
	myFavouriteTournaments: 'My favorite tournaments',
	visitor: 'Visitante',
	watchMatch: 'Ver partido',
	editVideos: 'Editar videos',
	addPictures: 'Agregar imagenes',
	toUpdate: 'Actualizar',
	editMatch: 'Editar los resultados del partido',
	participated: 'Participó',
	none: 'Ninguno',
	changeResultMatch: 'Cambiar resultado de un partido',
	changeResults: 'Cambiar los resultados',
	changeStatistics: 'Cambiar las estadísticas',
	enabledStatistics: 'Habilitar la edición de las estadísticas',
	all: 'Todo',
	coins: 'Monedas',
	duration: 'Duración',
	toBuy: 'Comprar',
	relatedProducts: 'Productos relacionados',
	boughtOn: 'Comprado el',
	beatOn: 'Vence el',
	use: 'USAR',
	addCategory: 'Agregar categoría',
	bgTournaments: 'Imagen de fondo para los torneos',
	bgDivisions: 'Imagen de fondo para las divisiones',
	bgTeams: 'Imagen de fondo para los equipos',
	bgPlayers: 'Background image for players',
	editCategory: 'Editar categoría',
	addSubcategory: 'Agregar subcategoría',
	editSubcategory: 'Editar subcategoría',
	createProduct: 'Crear producto',
	editProduct: 'Editar producto',
	visible: 'Visible',
	cardNumber: 'Número de tarjeta',
	expirationDate: 'Fecha de expiración',
	matchBetting: 'Apuesta del partido',
	matchWin: 'Ganancia del partido',
	bet: 'Apuesta',
	gain: 'Ganancia',
	matchesBet: 'Partidos con apuesta',
	entry: 'Entrada',
	betMsgEntry:
		'Se descontara (<strong>{coin}</strong>) de tus monedas para jugar este partido',
	confirmResults: 'Confirmar resultados',
	whatLokingFor: '¿Que estás buscando?',
	textFind: 'Ingrese 3 letras ó carácteres',
	searchResults: 'Resultados de tu búsqueda',
	seeCard: 'Ver tarjeta',
	only15Letters: 'Solo 15 caracteres.',
	rename: 'Cambiar nombre',
	sendLinkResetPassword: 'Correo cambiar contraseña',
	end: 'FIN',
	deliverPrizes: 'Entregar premios',
	confirm: 'Confirmar',
	awardsConfirmText:
		'¿Estas seguro de continuar? <br />Esta opción no se puede deshacer.',
	donateTitle: 'Apreciamos el apoyo brindado',
	donateThanks: 'Gracias por tu apoyo.',
	donateText:
		'<p>La organización ITFA America les agradece a todas las personas que de una u otra manera valoran el arduo trabajo realizado por la administración de esta pagina en la cual se organizan múltiples torneos de mucho renombre y alta competitividad.</p><p>A todos estos patrocinadores que de manera anónima realizan.</p><p>Les agradecemos de corazón el aporte, ya que nos motivan a seguir adelante con este gran proyecto mejorando la pagina y manteniéndola.</p>',
	donate: 'donación | donaciones',
	amountToDonate: 'Cantidad a donar',
	premiumForMonth: 'Precio válido por 1 mes | Precio válido por {month} meses',
	priceForMonth: '1 mes | {month} meses',
	movements: 'Movimientos',
	transferIn: '{player} ahora es jugador del {team}',
	transferOut: '{player} salió del club {team}',
	changeCup: 'Cambiar copa',
	banned: 'Baneados',
	reason: 'Razón',
	bannedStart: 'Inició',
	bannedEnd: 'Baneado hasta',
	countries: 'Países',
	change: 'Cambiar',
}
